import { render, staticRenderFns } from "./RecoveryOptions.vue?vue&type=template&id=81896b82&scoped=true&"
import script from "./RecoveryOptions.vue?vue&type=script&lang=js&"
export * from "./RecoveryOptions.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryOptions.vue?vue&type=style&index=0&id=81896b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81896b82",
  null
  
)

export default component.exports